export default __webpack_public_path__ + "static/media/bootstrap.b843cb05.png";